<label for="universal-datepicker" class="d-none">Mês e ano</label>
<input class="d-none" readonly [matDatepicker]="datePicker" [formControl]="date" id="universal-datepicker">
<ng-content></ng-content>
<mat-datepicker #datePicker startView="multi-year" [touchUi]="isMobile" (monthSelected)="setMonthAndYear($event)"></mat-datepicker>
